import React from 'react';

export type TournamentTabId = 'principal' | 'inscreva-se' | 'categorias' | 'seguidores';

interface TournamentTabsProps {
  activeTab: TournamentTabId;
  onTabChange: (tab: TournamentTabId) => void;
  principalContent?: React.ReactNode;
  inscrevaSeContent: React.ReactNode;
  categoriasContent?: React.ReactNode;
  seguidoresContent?: React.ReactNode;
}

const placeholder = (
  <div className="text-center py-4">
    <p className="text-muted">Em breve</p>
  </div>
);

const TournamentTabs: React.FC<TournamentTabsProps> = ({
  activeTab,
  onTabChange,
  principalContent,
  inscrevaSeContent,
  categoriasContent,
  seguidoresContent,
}) => {
  return (
    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3">
      <div className="card-body p-0">
        {/* Abas */}
        <ul className="nav nav-tabs border-0 px-3 pt-3" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'principal' ? 'active' : ''}`}
              id="principal-tab"
              type="button"
              role="tab"
              aria-controls="principal"
              aria-selected={activeTab === 'principal'}
              onClick={() => onTabChange('principal')}
            >
              Principal
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'inscreva-se' ? 'active' : ''}`}
              id="inscreva-se-tab"
              type="button"
              role="tab"
              aria-controls="inscreva-se"
              aria-selected={activeTab === 'inscreva-se'}
              onClick={() => onTabChange('inscreva-se')}
            >
              Inscreva-se
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'categorias' ? 'active' : ''}`}
              id="categorias-tab"
              type="button"
              role="tab"
              aria-controls="categorias"
              aria-selected={activeTab === 'categorias'}
              onClick={() => onTabChange('categorias')}
            >
              Categorias
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'seguidores' ? 'active' : ''}`}
              id="seguidores-tab"
              type="button"
              role="tab"
              aria-controls="seguidores"
              aria-selected={activeTab === 'seguidores'}
              onClick={() => onTabChange('seguidores')}
            >
              Seguidores
            </button>
          </li>
        </ul>

        {/* Divisória */}
        <div className="border-top"></div>

        {/* Conteúdo das Abas */}
        <div className="tab-content p-3">
          <div
            className={`tab-pane fade ${activeTab === 'principal' ? 'show active' : ''}`}
            id="principal"
            role="tabpanel"
            aria-labelledby="principal-tab"
          >
            {principalContent ?? placeholder}
          </div>
          <div
            className={`tab-pane fade ${activeTab === 'inscreva-se' ? 'show active' : ''}`}
            id="inscreva-se"
            role="tabpanel"
            aria-labelledby="inscreva-se-tab"
          >
            {inscrevaSeContent}
          </div>
          <div
            className={`tab-pane fade ${activeTab === 'categorias' ? 'show active' : ''}`}
            id="categorias"
            role="tabpanel"
            aria-labelledby="categorias-tab"
          >
            {categoriasContent ?? placeholder}
          </div>
          <div
            className={`tab-pane fade ${activeTab === 'seguidores' ? 'show active' : ''}`}
            id="seguidores"
            role="tabpanel"
            aria-labelledby="seguidores-tab"
          >
            {seguidoresContent ?? placeholder}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TournamentTabs;
